// extracted by mini-css-extract-plugin
module.exports = {"pageSubtitle":"viewKVMemberProcess_pageSubtitle__1VIX_","userPic":"viewKVMemberProcess_userPic__2Hfmm"};